import SMSApi from '@/api/merchant-sms'

const state = {
}

const mutations = {
}

const actions = {
  async listSigns ({ commit }, query) {
    const result = await SMSApi.listSigns(query)
    return result
  },
  async allSigns ({ commit }, query) {
    const result = await SMSApi.allSigns(query)
    return result
  },
  async getSignById({ commit }, id) {
    const result = await SMSApi.getSignById(id)
    return result
  },
  async addSign ({ commit }, data) {
    const result = await SMSApi.addSign(data)
    return result
  },
  async updateSign ({ commit }, data) {
    const result = await SMSApi.updateSign(data)
    return result
  },
  async submitAuditSign ({ commit }, id) {
    const result = await SMSApi.submitAuditSign(id)
    return result
  },
  async cancelAuditSign ({ commit }, id) {
    const result = await SMSApi.cancelAuditSign(id)
    return result
  },
  async listTemplates ({ commit }, query) {
    const result = await SMSApi.listTemplates(query)
    return result
  },
  async getTemplateById ({ commit }, id) {
    const result = await SMSApi.getTemplateById(id)
    return result
  },
  async addTemplate ({ commit }, data) {
    const result = await SMSApi.addTemplate(data)
    return result
  },
  async updateTemplate ({ commit }, data) {
    const result = await SMSApi.updateTemplate(data)
    return result
  },
  async submitAuditTemplate ({ commit }, id) {
    const result = await SMSApi.submitAuditTemplate(id)
    return result
  },
  async cancelAuditTemplate ({ commit }, id) {
    const result = await SMSApi.cancelAuditTemplate(id)
    return result
  },
  async listContacts ({ commit }, query) {
    const result = await SMSApi.listContacts(query)
    return result
  },
  async getContactById ({ commit }, id) {
    const result = await SMSApi.getContactById(id)
    return result
  },
  async addContact ({ commit }, data) {
    const result = await SMSApi.addContact(data)
    return result
  },
  async updateContact ({ commit }, data) {
    const result = await SMSApi.updateContact(data)
    return result
  },
  async removeContact ({ commit }, data) {
    const result = await SMSApi.removeContact(data)
    return result
  },
  async uploadContacts ({ commit }, forms) {
    const result = await SMSApi.uploadContacts(forms)
    return result
  },
  async uploadSimpleContacts ({ commit }, forms) {
    const result = await SMSApi.uploadSimpleContacts(forms)
    return result.data
  },
  async listContactGroups ({ commit }, query) {
    const result = await SMSApi.listContactGroups(query)
    return result
  },
  async allContactGroups ({ commit }, query) {
    const result = await SMSApi.allContactGroups(query)
    return result
  },
  async getContactGroupById ({ commit }, id) {
    const result = await SMSApi.getContactGroupById(id)
    return result
  },
  async addContactGroup ({ commit }, data) {
    const result = await SMSApi.addContactGroup(data)
    return result
  },
  async updateContactGroup ({ commit }, data) {
    const result = await SMSApi.updateContactGroup(data)
    return result
  },
  async removeContactGroup ({ commit }, data) {
    const result = await SMSApi.removeContactGroup(data)
    return result
  },
  async addContactsToContactGroup ({ commit }, data) {
    const result = await SMSApi.addContactsToContactGroup(data)
    return result
  },
  async removeContactFromContactGroup ({ commit }, data) {
    const result = await SMSApi.removeContactFromContactGroup(data)
    return result
  },
  async sendMessage ({ commit }, data) {
    const result = await SMSApi.sendMessage(data)
    return result
  },
  async listMessages ({ commit }, query) {
    const result = await SMSApi.listMessages(query)
    return result
  },
  async listPackages ({ commit }, query) {
    const result = await SMSApi.listPackages(query)
    return result
  },
  async listGoods ({ commit }, query) {
    const result = await SMSApi.listGoods(query)
    return result
  },
  async getPaymentUrl ({ commit }, data) {
    const result = await SMSApi.getPaymentUrl(data)
    return result
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-sms.js